export const hideFromPublicReasons = [
  'Πουλήθηκε',
  'Ψευτικα στοιχεία',
  'Τηλ/link στην περιγραφή'
]
